import { createMutation, createQuery } from "react-query-kit";
import { api } from "../../api";
import {
  GetTermsAndConditionPreviewResponse,
  GetWBEConfigResponse,
  LanguageCode,
} from "../../contracts/site-config";

// GET /api/public/sites/config/{slug}
export const useWBEConfig = createQuery<GetWBEConfigResponse, { slug: string }>(
  {
    queryKey: ["useWBEConfig"],
    fetcher: ({ slug }) =>
      api.get<GetWBEConfigResponse>(`/api/public/sites/config/${slug}`),
  },
);

// GET /api/public/sites/preview/{siteId}/{termId}?languageCode={languageCode}
export const useGetTermsAndConditionPreviewMutation = createMutation<
  GetTermsAndConditionPreviewResponse,
  { termId: string; languageCode: LanguageCode; siteId: string }
>({
  mutationFn: async ({ termId, languageCode, siteId }) => {
    return api.get<GetTermsAndConditionPreviewResponse>(
      `/api/public/sites/preview/${siteId}/${termId}?languageCode=${languageCode}`,
    );
  },
});
